import { styled } from '@obvio/app'
import { Stack } from '@obvio/ui'

import type { ReactElement } from 'react'

const Wrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const RightPanel = styled(Stack)`
  align-items: center;
`

type CategoryNavProps = {
  title: string
  productsCount: number
}

export function CategoryNav({
  title,
  productsCount,
}: CategoryNavProps): ReactElement {
  return (
    <Wrap>
      <span>{`ZRÓB ZAKUPY / ${title}`}</span>
      <RightPanel>
        <span>{`${productsCount}`} produkty</span>
        {/* <span>SORTUJ</span> */}
      </RightPanel>
    </Wrap>
  )
}
